import { environment } from '@env/environment';

export function inProduction(): boolean {
    return environment.name === 'production';
}
